import React from 'react';
import { PenLine, Bold, Italic, Underline, Heading1, Heading2, List, ListOrdered, AlignLeft, AlignCenter, AlignRight, AlignJustify, Undo2, Redo2 } from 'lucide-react';

const TAMANOS = ['9pt', '10pt', '11pt', '12pt', '14pt', '16pt', '18pt'];

const Btn = ({ on, active, title, testid, children }) => (
  <button type="button" title={title} data-testid={testid} onMouseDown={(e) => { e.preventDefault(); on(); }}
    className={`h-8 w-8 flex items-center justify-center rounded transition-colors ${active ? 'bg-violet-600 text-white' : 'hover:bg-gray-200 text-gray-700'}`}>
    {children}
  </button>
);

export const NotaToolbar = ({ editor, paginas }) => {
  if (!editor) return null;
  const c = () => editor.chain().focus();
  const tam = editor.getAttributes('textStyle').fontSize || '11pt';
  let tieneFirma = false;
  editor.state.doc.descendants(n => { if (n.type.name === 'firmaBloque') tieneFirma = true; });
  const sep = <span className="w-px h-6 bg-gray-300 mx-1" />;
  return (
    <div className="flex flex-wrap items-center gap-0.5 p-1.5 border rounded-lg bg-white sm:sticky sm:top-0 z-10" data-testid="nota-toolbar">
      <Btn title="Negrita" testid="nota-tb-bold" active={editor.isActive('bold')} on={() => c().toggleBold().run()}><Bold className="w-4 h-4" /></Btn>
      <Btn title="Cursiva" testid="nota-tb-italic" active={editor.isActive('italic')} on={() => c().toggleItalic().run()}><Italic className="w-4 h-4" /></Btn>
      <Btn title="Subrayado" testid="nota-tb-underline" active={editor.isActive('underline')} on={() => c().toggleUnderline().run()}><Underline className="w-4 h-4" /></Btn>
      {sep}
      <Btn title="Título" testid="nota-tb-h1" active={editor.isActive('heading', { level: 1 })} on={() => c().toggleHeading({ level: 1 }).run()}><Heading1 className="w-4 h-4" /></Btn>
      <Btn title="Subtítulo" testid="nota-tb-h2" active={editor.isActive('heading', { level: 2 })} on={() => c().toggleHeading({ level: 2 }).run()}><Heading2 className="w-4 h-4" /></Btn>
      <Btn title="Lista" testid="nota-tb-ul" active={editor.isActive('bulletList')} on={() => c().toggleBulletList().run()}><List className="w-4 h-4" /></Btn>
      <Btn title="Lista numerada" testid="nota-tb-ol" active={editor.isActive('orderedList')} on={() => c().toggleOrderedList().run()}><ListOrdered className="w-4 h-4" /></Btn>
      {sep}
      {[['left', AlignLeft, 'Izquierda'], ['center', AlignCenter, 'Centro'], ['right', AlignRight, 'Derecha'], ['justify', AlignJustify, 'Justificado']].map(([a, Icon, t]) => (
        <Btn key={a} title={t} testid={`nota-tb-align-${a}`} active={editor.isActive({ textAlign: a })} on={() => c().setTextAlign(a).run()}><Icon className="w-4 h-4" /></Btn>
      ))}
      {sep}
      <select className="h-8 border rounded px-1 text-sm" value={tam} data-testid="nota-tb-fontsize"
        onChange={(e) => (e.target.value === '11pt' ? c().unsetFontSize().run() : c().setFontSize(e.target.value).run())}>
        {TAMANOS.map(t => <option key={t} value={t}>{t.replace('pt', '')}</option>)}
      </select>
      {sep}
      <Btn title="Deshacer" testid="nota-tb-undo" on={() => c().undo().run()}><Undo2 className="w-4 h-4" /></Btn>
      <Btn title="Rehacer" testid="nota-tb-redo" on={() => c().redo().run()}><Redo2 className="w-4 h-4" /></Btn>
      {sep}
      <button type="button" data-testid="nota-tb-insertar-firma" onMouseDown={(e) => { e.preventDefault(); editor.view.domObserver?.flush?.(); c().insertarFirma().run(); }}
        className="h-8 px-2 flex items-center gap-1 rounded bg-violet-50 text-violet-700 hover:bg-violet-100 text-sm font-medium">
        <PenLine className="w-4 h-4" /> {tieneFirma ? 'Mover firma aquí' : 'Insertar firma'}
      </button>
      {!tieneFirma && <span className="text-xs text-amber-600 ml-1" data-testid="nota-sin-firma-aviso">Sin firma insertada: se agregará al final</span>}
      <span className="ml-auto text-xs text-gray-500 pr-2" data-testid="nota-paginas-count">{paginas} {paginas === 1 ? 'hoja' : 'hojas'}</span>
    </div>
  );
};
